module.exports = __webpack_public_path__ + "img/cloth_g3_pants-02.a4a830d3.svg";